export function formatRecords (records) {
  return records.map(record => { return { id: record.id, ...record.fields } })
}
